import React from 'react';
import { Mail, MapPin } from 'lucide-react';
import { COPY } from '../../i18n/copy';
import { useI18n } from '../../i18n/useI18n';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const { lang } = useI18n();
  const c = COPY[lang];
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-200">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <div className="text-base font-semibold text-white">ERICA</div>
            <div className="mt-1 text-xs text-slate-400">
              {lang === 'id' ? 'oleh Rekayasa' : 'by Rekayasa'}
            </div>
            <p className="mt-4 text-sm text-slate-300">{c.footer.tagline}</p>

            <div className="mt-6 space-y-3 text-sm">
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-slate-300" />
                <a href="mailto:sales@rekayasa.io" className="hover:text-white">
                  sales@rekayasa.io
                </a>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-slate-300" />
                <span>{c.footer.location}</span>
              </div>
            </div>
          </div>

          <div />

          <div>
            <div className="text-sm font-semibold text-white">{c.footer.legal}</div>
            <ul className="mt-4 space-y-3 text-sm text-slate-300">
              <li>
                <Link to="/company" className="hover:text-white">
                  {c.footer.company}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-white">
                  {c.footer.privacy}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-white">
                  {c.footer.terms}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-slate-800 pt-8 text-center text-xs text-slate-400">
          © {currentYear} {c.footer.copyright}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
